import { LayoutPages } from "../../layoutPages";
import { HOME_ROUTE, STUDENT_CREATE_ROUTE, STUDENTS_ARCHIVE_ROUTE, STUDENTS_ROUTE } from "../../../app/router/routes";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import classes from './studentsLayout.module.scss'
import { SwitchButton } from "../../../shared/ui/switchButton";
import { useAppSelector } from "../../../app/store/store";
import { StudentFilters } from "../../../widgets/studentFilters";
import { MyButton } from "../../../shared/ui/button";
import { useState } from "react";
import { AdminActionsStudents } from "../../../widgets/adminActionStudents";
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from "../../../entities/my";


export default function StudentsLayoutPage() {
    
    const {pathname} = useLocation()
    const router = useNavigate()
    const [trigger, setTrigger] = useState<boolean>(false) // при смене платежки у всех студентов, обновляем список студентов

    const title = pathname === STUDENTS_ROUTE.path ? STUDENTS_ROUTE.name : STUDENTS_ARCHIVE_ROUTE.name;

    const isStudent = pathname === '/students';

    const {my} = useAppSelector(s => s.myReducer)
    const isTutor = my.role === 'tutor'
    const canOpenStudentsSection = hasFeature(my, FEATURE_SECTIONS.STUDENTS)
    const canListStudents = hasFeatureGrant(my, FEATURES.STUDENTS.LIST)
    const canCreateStudent = hasFeature(my, FEATURES.STUDENTS.CREATE)
        && hasFeatureGrant(my, FEATURES.IDM.STAFF_LIST)
        && hasFeature(my, FEATURES.WORK_TGS.LIST)
    const canOpenArchive = hasFeatureGrant(my, FEATURES.FRONT.STUDENT_ARCHIVE)
    const showStudentFilters = canListStudents && !isTutor
    const showStudentActions = isStudent && !isTutor
    const hasHeaderControls = canCreateStudent || canOpenArchive
    const hasPageControls = showStudentFilters || showStudentActions
    const hasControls = hasHeaderControls || hasPageControls

    const onSwitchPage = (selectedPage: 1 | 2) => {
        if(selectedPage === 1) { // students
            router(STUDENTS_ROUTE.path)
        }
        else { // students_archive
            router(STUDENTS_ARCHIVE_ROUTE.path)
        }
    }

    if(!canOpenStudentsSection){
        return <Navigate to={HOME_ROUTE.path} replace />
    }

    return (
        <LayoutPages title={title}>
            {
                hasControls
                    &&
                <>
                {
                    hasHeaderControls
                        &&
                    <section className={classes.header}>
                    {
                        canOpenArchive
                            &&
                        <section className={classes.switchButton}>
                            <SwitchButton
                                text1="Студенты"
                                text2="Архив студентов"
                                onSelected={onSwitchPage}
                                selected={isStudent ? 1 : 2}
                            />
                        </section>
                    }
                    <section className={classes.wrap}>
                        {
                            isStudent
                                &&
                            <>
                            {
                                canCreateStudent
                                    &&
                                <section className={classes.add}>
                                    <MyButton onClick={() => router(STUDENT_CREATE_ROUTE.path)}>
                                        Добавить студента
                                    </MyButton>
                                </section>
                            }
                            </>
                        }
                    </section>
                    </section>
                }
                {
                    hasPageControls
                        && 
                    <section className={classes.controls}>
                        {
                            showStudentFilters
                                &&
                            <section className={classes.filter}>
                                <StudentFilters />
                            </section>}
                        {
                        showStudentActions
                            &&
                        <section className={classes.adminActionsStudents}>
                            <AdminActionsStudents 
                                trigger={trigger} 
                                setTrigger={setTrigger} 
                            />
                        </section>
                    }
                </section>}
            </>
            }
            <section className={classes.students + (hasControls ? ` ${classes.permission}` : '')}>
                <Outlet context={trigger} />
            </section>
        </LayoutPages>
    )
}
